import React from "react";
import Popup from "../../components/Popup/index";
import Table from "../../components/Table";
import { FinancialPopupStyle, PopupCloseButton } from "./styled";

const FinancialPopup = (props) => {
  return (
    <Popup
      type="default"
      show={props.show}
      summary="정도경영을 바탕으로 
        지속적으로 성장하는 KB데이타시스템이 되겠습니다."
      title="재무정보"
      top="0%"
      onClose={props.onClose}
    >
      <FinancialPopupStyle>
        {/* <Financial/> */}

        <div class="cs">
          <p class="copy"></p>
          <div class="cs2">
            <h4>요약손익계산서</h4>
            <Table
              cellspacing="0"
              summary="KB데이타시스템 요약손익계산서입니다."
            >
              <caption>
                KB데이타시스템 요약손익계산서 <small>(단위 : 백만원)</small>
              </caption>
              <thead>
                <tr>
                  <th width="150px">구분</th>
                  <th scope="col">2023년</th>
                  <th scope="col">2024년</th>
                  <th scope="col">2025년</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">매출액</th>
                  <td>
                    <span>230,825</span>
                  </td>
                  <td>
                    <span>241,652</span>
                  </td>
                  <td>
                    <span>295,401</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">매출원가</th>
                  <td>
                    <span>218,394</span>
                  </td>
                  <td>
                    <span>227,560</span>
                  </td>
                  <td>
                    <span>272,096</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">매출총이익</th>
                  <td>
                    <span>12,430</span>
                  </td>
                  <td>
                    <span>14,092</span>
                  </td>
                  <td>
                    <span>23,305</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">판매비와일반관리비</th>
                  <td>
                    <span>13,184</span>
                  </td>
                  <td>
                    <span>12,550</span>
                  </td>
                  <td>
                    <span>13,861</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">영업이익</th>
                  <td>
                    <span>-754</span>
                  </td>
                  <td>
                    <span>1,542</span>
                  </td>
                  <td>
                    <span>9,444</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">영업외손익</th>
                  <td>
                    <span>953</span>
                  </td>
                  <td>
                    <span>1,156</span>
                  </td>
                  <td>
                    <span>589</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">세전이익</th>
                  <td>
                    <span>200</span>
                  </td>
                  <td>
                    <span>2,698</span>
                  </td>
                  <td>
                    <span>10,034</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">법인세비용</th>
                  <td>
                    <span>66</span>
                  </td>
                  <td>
                    <span>720</span>
                  </td>
                  <td>
                    <span>2,436</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">당기순이익</th>
                  <td>
                    <span>134</span>
                  </td>
                  <td>
                    <span>1,978</span>
                  </td>
                  <td>
                    <span>7,598</span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>

          <div class="cs2">
            <h4>요약재무상태표</h4>
            <Table>
              <caption>
                KB데이타시스템 요약재무상태표 <small>(단위 : 백만원)</small>
              </caption>
              <thead>
                <tr>
                  <th width="150px">구분</th>
                  <th scope="col">2023년</th>
                  <th scope="col">2024년</th>
                  <th scope="col">2025년</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">유동자산</th>
                  <td>
                    <span>48,753</span>
                  </td>
                  <td>
                    <span>49,405</span>
                  </td>
                  <td>
                    <span>69,234</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비유동자산</th>
                  <td>
                    <span>12,756</span>
                  </td>
                  <td>
                    <span>12,865</span>
                  </td>
                  <td>
                    <span>16,055</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">자산총계</th>
                  <td>
                    <span>61,509</span>
                  </td>
                  <td>
                    <span>62,270</span>
                  </td>
                  <td>
                    <span>85,289</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">유동부채</th>
                  <td>
                    <span>38,550</span>
                  </td>
                  <td>
                    <span>37,999</span>
                  </td>
                  <td>
                    <span>52,042</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비유동부채</th>
                  <td>
                    <span>2,066</span>
                  </td>
                  <td>
                    <span>2,220</span>
                  </td>
                  <td>
                    <span>3,148</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">부채총계</th>
                  <td>
                    <span>40,616</span>
                  </td>
                  <td>
                    <span>40,219</span>
                  </td>
                  <td>
                    <span>55,190</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">자본금</th>
                  <td>
                    <span>8,000</span>
                  </td>
                  <td>
                    <span>8,000</span>
                  </td>
                  <td>
                    <span>8,000</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">이익잉여금</th>
                  <td>
                    <span>17,959</span>
                  </td>
                  <td>
                    <span>19,937</span>
                  </td>
                  <td>
                    <span>27,637</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">자본총계</th>
                  <td>
                    <span>20,892</span>
                  </td>
                  <td>
                    <span>22,051</span>
                  </td>
                  <td>
                    <span>30,099</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">부채와 자본총계</th>
                  <td>
                    <span>61,509</span>
                  </td>
                  <td>
                    <span>62,270</span>
                  </td>
                  <td>
                    <span>85,289</span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </FinancialPopupStyle>
      <PopupCloseButton>
        <a href="/#" onClick={props.onClose}>
          닫기
        </a>
      </PopupCloseButton>
    </Popup>
  );
};

export default FinancialPopup;
